/**
 * Pure permission-check helpers shared by the role store and the unit tests.
 *
 * Keeping these free of pinia / axios / localStorage makes the exact permission
 * rules testable in isolation and guarantees the tests exercise the same logic
 * the app uses at runtime.
 */

/**
 * Does the given permission list satisfy `cls.perm` for ANY of `perms`?
 * Mirrors useRoleStore().hasPerms.
 *
 * @param {string[]} permissions  flat list of "cls.key" strings
 * @param {boolean}  isSuperAdmin super admins bypass all checks
 * @param {string}   cls          permission class (e.g. "content_team")
 * @param {string|string[]} perms one or more action keys (OR semantics)
 * @returns {boolean}
 */
export function hasPermsCheck(permissions, isSuperAdmin, cls, perms) {
  if (isSuperAdmin) {
    return true;
  }
  if (!cls || !perms) {
    return true;
  }

  const list = permissions || [];

  if (typeof perms === 'string') {
    return list.indexOf(cls + '.' + perms) > -1;
  }

  if (perms.length === 0) {
    return true;
  }

  let flag = false;
  perms.forEach(p => {
    if (list.indexOf(cls + '.' + p) > -1) {
      flag = true;
    }
  });
  return flag;
}
